import { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';
import context, { IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';

class ComponentInitializer implements IInitializer {
    name: string = 'ComponentInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.component('fleet-upgrade', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-upgrade" */ './FleetUpgrade.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('members', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-members" */ './Members/Members.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('duplicate-accounts', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-duplicate-accounts" */ './DuplicateAccounts/DuplicateAccounts.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('users', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-users" */ './Users/Users.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('user-list', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-user-list" */ './Users/UserList/UserList.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('user-profile', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-user-profile" */ './Users/UserProfile/UserProfile.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('integrations', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-integrations" */ './Integrations/Integrations.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('company-information', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-company-information" */ './CompanyInformation/CompanyInformation.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-account-admin', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-account-admin" */ './EditAccountAdmin/EditAccountAdmin.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('timezone-lookup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-timezone-lookup" */ './TimeZoneLookup/TimeZoneLookup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup" */ './FleetSetup/FleetSetup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-company-address', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-company-address" */ './CompanyInformation/EditCompanyAddress/EditCompanyAddress.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-company-info', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-company-info" */ './CompanyInformation/EditCompanyInformation/EditCompanyInfo.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-fleet-info', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-fleet-info" */ './CompanyInformation/EditFleetInfo/EditFleetInfo.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('add-user-admin', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-add-user-admin" */ './Users/AddUserAdmin/AddUserAdmin.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('purged-users', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-purged-users" */ './Users/PurgedUsers/PurgedUsers.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-admin-settings', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-admin-settings" */ './Users/UserProfile/EditAdminSettings/EditAdminSettings.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-user-info', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-user-info" */ './Users/UserProfile/EditUserInfo/EditUserInfo.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-user-preferences', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-user-preferences" */ './Users/UserProfile/EditUserPreferences/EditUserPreferences.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-email-address', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-email-address" */ './Users/UserProfile/EditEmailAddress/EditEmailAddress.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-mobile-number', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-mobile-number" */ './Users/UserProfile/EditMobileNumber/EditMobileNumber.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-security-settings', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-security-settings" */ './Users/UserProfile/EditSecuritySettings/EditSecuritySettings.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('change-password', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-change-password" */ './Users/UserProfile/ChangePassword/ChangePassword.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('move-user-admin', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-move-user-admin" */ './Users/UserProfile/MoveUserAdmin/MoveUserAdmin.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('refresh-api-key', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-refresh-api-key" */ './Integrations/RefreshApiKey/RefreshApiKey.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('remove-api-key', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-remove-api-key" */ './Integrations/RemoveApiKey/RemoveApiKey.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-api-key', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-edit-api-key" */ './Integrations/EditApiKey/EditApiKey.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('add-api-key', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-add-api-key" */ './Integrations/AddApiKey/AddApiKey.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('add-webhook', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-add-webhook" */ './Integrations/AddWebhook/AddWebhook.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('verify-webhook', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-verify-webhook" */ './Integrations/VerifyWebhook/VerifyWebhook.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-progress-tracker', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-progress-tracker" */ './FleetSetup/ProgressTracker/ProgressTracker.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-side-bar', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-side-bar" */ './FleetSetup/SideBar/SideBar.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-step-summary', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-step-summary" */ './FleetSetup/StepSummary/StepSummary.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-step-title', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-step-title" */ './FleetSetup/StepTitle/StepTitle.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-team-setup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-team-setup" */ './FleetSetup/TeamSetup/TeamSetup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-favorites-setup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-favorites-setup" */ './FleetSetup/FavoritesSetup/FavoritesSetup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-vendors-setup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-vendors-setup" */ './FleetSetup/VendorsSetup/VendorsSetup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('fleet-setup-activate', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-accounts-fleet-setup-activate" */ './FleetSetup/Activate/Activate.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        return Promise.resolve();
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ComponentInitializer();
    }
});
